import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48701ff1")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_my_button = _resolveComponent("my-button")

  return (_openBlock(), _createBlock(_component_my_button, {
    class: ["button", _ctx.className],
    type: 'primary',
    loading: _ctx.basicLoading,
    disabled: _ctx.basicDisabled
  }, {
    default: _withId(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "loading", "disabled"]))
})